var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSwishLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 14,
    viewBox: "0 0 248 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.591356 11.993C0.591356 11.993 99.9975 -5.55007 246.859 7.32638",
    stroke: "#F4BC22",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwishLine);
export default __webpack_public_path__ + "static/media/icon_swishLine.0b0277c2b7774179754ec68a7cadeae0.svg";
export { ForwardRef as ReactComponent };